import { ServiceMaker, methods, services } from "@/services";

export const listfaq = () =>
  ServiceMaker(`/faq/list-faq`, methods.GET, services.master);

export const createFaq = (data) =>
  ServiceMaker(`/faq/faq`, methods.POST, services.master, data);

export const updateFaq = (id, data) =>
  ServiceMaker(`/faq/faq/${id}`, methods.PUT, services.master, data);

export const deleteFaq = (id) =>
  ServiceMaker(`/faq/faq/${id}`, methods.DELETE, services.master);

export const faqs = (scope) =>
  ServiceMaker(
    `/faq/filter-faq?scope=${scope}&query=`,
    methods.GET,
    services.master
  );
